// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminCenterApiService } from './_internal/admin-center.api.service';
import { SearchRequestInterface } from './_internal/interfaces';
import {
  GetAppConfigResponse,
  GetHealthCheckResponse,
  GetPluginUpdatesCountResponse,
  SearchPidHealthResponse,
  SearchResponse,
} from './_internal/objects';
import { SearchApiService } from './_internal/search.api.service';

@Injectable({ providedIn: 'root' })
export class AdminCenterService {
  constructor(private adminCenterApiService: AdminCenterApiService, private searchApiService: SearchApiService) {}

  getAppConfig(partnerId: string): Observable<GetAppConfigResponse> {
    return this.adminCenterApiService.getAppConfig({ partnerId: partnerId });
  }

  setShowAdvancedFeatures(partnerId: string, showAdvancedFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowAdvancedFeatures({
      partnerId: partnerId,
      showAdvancedFeatures: showAdvancedFeatures,
    });
  }

  setShowIncludedTemplates(partnerId: string, showIncludedTemplates: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowIncludedTemplates({
      partnerId: partnerId,
      showIncludedTemplates: showIncludedTemplates,
    });
  }

  setShowDomainsFeatures(partnerId: string, showDomainsFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowDomainsFeatures({
      partnerId: partnerId,
      showDomainsFeatures: showDomainsFeatures,
    });
  }

  setShowImportFeatures(partnerId: string, showImportFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowImportFeatures({
      partnerId: partnerId,
      showImportFeatures: showImportFeatures,
    });
  }

  setShowBackupsFeatures(partnerId: string, showBackupsFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowBackupsFeatures({
      partnerId: partnerId,
      showBackupFeatures: showBackupsFeatures,
    });
  }

  setShowStagingFeatures(partnerId: string, showStagingFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowStagingFeatures({
      partnerId: partnerId,
      showStagingFeatures: showStagingFeatures,
    });
  }

  search(r: SearchRequestInterface): Observable<SearchResponse> {
    return this.searchApiService.search(r);
  }

  getPluginUpdatesCount(partnerId: string): Observable<GetPluginUpdatesCountResponse> {
    return this.searchApiService.getPluginUpdatesCount({ partnerId: partnerId });
  }

  getPidHealthData(partnerId: string): Observable<SearchPidHealthResponse> {
    return this.searchApiService.getPidHealthData({ partnerId: partnerId });
  }

  getSiteHealthChecks(siteId: []): Observable<GetHealthCheckResponse> {
    return this.searchApiService.getSiteHealthChecks({ siteId: siteId });
  }
}
